import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  contentContainer: {
    marginTop: 56,
    padding: '24px',
  },
  headerContainer: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  titleWrapper: {
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
  },
  actionWrapper: {
    textAlign: 'end',
    [theme.breakpoints.up('sm')]: {
      width: '20%',
    },
  },
  frameContainer: {
    padding: '24px 0',
    height: '90%',
  },
  widget: {
    height: '70vh',
    [theme.breakpoints.down('sm')]: {
      height: '64vh',
    },
  },
  infoBanner: {
    padding: '8px 0',
  },
  footerWrapper: {
    textAlign: 'center',
    padding: 24,
  },
}));
